import React, { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import { Typography, Button, Grid } from "@material-ui/core";
import { Edit, Close, Save, HourglassEmpty } from "@material-ui/icons";
import parse from "html-react-parser";
import VideoTentangKami from "./VideoTentangKami";
import { Loading } from "../../../components";
import { Editor } from "../../../components";
import { getBeranda, postBeranda } from "../../../services";

const SekilasTentangKami = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loadingLoadState, setLoadingLoadState] = useState(false);
  const [loadingButtonState, setLoadingButtonState] = useState(false);
  const [openEditor, setOpenEditor] = useState(false);
  const [contentState, setContentState] = useState<any>({
    sekilasTentangKamiId: "",
    sekilasTentangKamiEn: "",
  });
  const [editVideoOrTextState, setEditVideoOrTextState] = useState({
    video: true,
    text: true,
  });

  const { sekilasTentangKamiId, sekilasTentangKamiEn } = contentState;

  const getData = async () => {
    try {
      setLoadingLoadState(true);
      const res = await getBeranda();
      if (res.status === "error") {
        enqueueSnackbar(res.message, {
          variant: "error",
        });
        return;
      }
      setContentState(res.data);
      setLoadingLoadState(false);
    } catch (err: any) {
      enqueueSnackbar(err.message, {
        variant: "error",
      });
    }
  };

  const writeData = async () => {
    try {
      setLoadingButtonState(true);
      const res = await postBeranda(contentState);
      setLoadingButtonState(false);
      if (res.status === "error") {
        enqueueSnackbar(res.message, {
          variant: "error",
        });
        return;
      }
      setOpenEditor(false);
      enqueueSnackbar(`Beranda Berhasil di update`, {
        variant: "success",
      });
    } catch (err: any) {
      setLoadingButtonState(false);
      enqueueSnackbar(err.message, {
        variant: "error",
      });
    }
  };

  const handleHideVideo = () => {
    setEditVideoOrTextState({
      video: false,
      text: true,
    });
  };

  const handleHideText = () => {
    setEditVideoOrTextState({
      video: true,
      text: false,
    });
  };

  const handleShowTextAndVideo = () => {
    setEditVideoOrTextState({
      video: true,
      text: true,
    });
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const contentId: any = sekilasTentangKamiId;
  const contentEn: any = sekilasTentangKamiEn;
  const paramId = "sekilasTentangKamiId";
  const paramEn = "sekilasTentangKamiEn";
  return (
    <>
      {editVideoOrTextState.video && (
        <VideoTentangKami
          onHideText={handleHideText}
          onShowTextAndVideo={handleShowTextAndVideo}
        />
      )}
      {editVideoOrTextState.text && (
        <>
          <div
            style={{
              marginTop: "3rem",
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "1rem",
            }}
          >
            {openEditor ? (
              <div>
                <Button
                  variant="outlined"
                  style={{ marginRight: 16 }}
                  size="large"
                  startIcon={<Close />}
                  onClick={() => {
                    handleShowTextAndVideo();
                    setOpenEditor(false);
                  }}
                  disabled={loadingButtonState}
                >
                  Cancel
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  size="large"
                  startIcon={loadingButtonState ? <HourglassEmpty /> : <Save />}
                  onClick={writeData}
                  disabled={loadingButtonState}
                >
                  {loadingButtonState ? "Loading" : "Save"}
                </Button>
              </div>
            ) : (
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<Edit />}
                onClick={() => {
                  handleHideVideo();
                  setOpenEditor(true);
                }}
                disabled={openEditor}
              >
                Edit
              </Button>
            )}
          </div>
          {openEditor ? (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography
                  color="primary"
                  variant="h6"
                  gutterBottom
                  style={{ marginBottom: "1rem" }}
                >
                  Bahasa Indonesia
                </Typography>
                <Editor
                  content={contentId}
                  onChange={(content: any) =>
                    setContentState({ ...contentState, [paramId]: content })
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  color="primary"
                  variant="h6"
                  gutterBottom
                  style={{ marginBottom: "1rem" }}
                >
                  English
                </Typography>
                <Editor
                  content={contentEn}
                  onChange={(content: any) =>
                    setContentState({ ...contentState, [paramEn]: content })
                  }
                />
              </Grid>
            </Grid>
          ) : loadingLoadState ? (
            <Loading />
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography color="primary" variant="h5" gutterBottom>
                  Sekilas Tentang Kami
                </Typography>
                <Typography
                  color="primary"
                  variant="h6"
                  gutterBottom
                  style={{ marginBottom: "1rem" }}
                >
                  Bahasa Indonesia
                </Typography>
                <div
                  style={{
                    padding: "1rem",
                    border: "1px solid rgb(241, 241, 241)",
                    borderRadius: 4,
                  }}
                  id="content"
                >
                  {parse(contentId)}
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography color="primary" variant="h5" gutterBottom>
                  A Little About Us
                </Typography>
                <Typography
                  color="primary"
                  variant="h6"
                  gutterBottom
                  style={{ marginBottom: "1rem" }}
                >
                  English
                </Typography>
                <div
                  style={{
                    padding: "1rem",
                    border: "1px solid rgb(241, 241, 241)",
                    borderRadius: 4,
                  }}
                  id="content"
                >
                  {parse(contentEn)}
                </div>
              </Grid>
            </Grid>
          )}
        </>
      )}
    </>
  );
};

export default SekilasTentangKami;
